var libs = {
    toEntities:function ($text){return $("<div/>").html($text).text();},
    base64 : {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) {
            var t = "";
            var n, r, i, s, o, u, a;
            var f = 0;
            e = Base64._utf8_encode(e);
            while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) {
                    u = a = 64
                } else if (isNaN(i)) {
                    a = 64
                }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
            }
            return t
        }, decode: function (e) {
            var t = "";
            var n, r, i;
            var s, o, u, a;
            var f = 0;
            e = e.replace(/[^A-Za-z0-9+/=]/g, "");
            while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) {
                    t = t + String.fromCharCode(r)
                }
                if (a != 64) {
                    t = t + String.fromCharCode(i)
                }
            }
            t = Base64._utf8_decode(t);
            return t
        }, _utf8_encode: function (e) {
            e = e.replace(/rn/g, "n");
            var t = "";
            for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r)
                } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                }
            }
            return t
        }, _utf8_decode: function (e) {
            var t = "";
            var n = 0;
            var r = c1 = c2 = 0;
            while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3
                }
            }
            return t
        }
    },
    getUrl : $(location).attr("href"),
    getObjForm:function($form){
        var $data = {};
        var $serialize = $($form).serializeArray();
        for (var $attr in $serialize) {
            if($data[$serialize[$attr].name] != undefined){
                if(Array.isArray($data[$serialize[$attr].name]) !== true){
                    var $first = $data[$serialize[$attr].name];
                    $data[$serialize[$attr].name] = [];
                    $data[$serialize[$attr].name].push($first);
                }
                $data[$serialize[$attr].name].push($serialize[$attr].value);
            }else {
                $data[$serialize[$attr].name] = $serialize[$attr].value;
            }
        }
        return $data;
    },
    ajaxSetup : function () {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    },
    isJson : function($data) {
        try {
            JSON.parse($data);
        } catch (e) {
            return false;
        }
        return true;
    },
    expire:function($data){
        try{
            if(libs.isJson($data)){
                $data = JSON.parse($data);
            }
            if($data.status == 'expire'){
                window.location = '/logout';
            }
            if($data.status == 'redirect'){
                window.location = $data.redirect;
            }
        }catch (error){

        }
    },
    render : function ($url, $module, $submodule, $params, $method) {
        $("#content").fadeOut();
        $(".loginText").fadeOut();
        if(!$method){$method = "GET";}
        $.ajax({
            url: $url,
            method: $method,
            cache:false,
            dataType: "html",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                $("#content").html($data).promise().done(function () {
                    $submodule = $submodule.replace(/\//g,'_');
                    eval($module + '.' + $submodule+'($params)');
                });
                $("#content").fadeIn();
                $(".loginText").fadeIn();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if($("#content").html() == ''){
                    libs.render($url, $module, $submodule, $params, $method);
                }
            }
        });
    },
    memorySave:function($name, $obj){
        if(window.$memory == undefined){
            window.$memory = {};
        }
        window.$memory[$name] = $obj;
    },
    memoryGet:function($name){
        if(window.$memory != undefined && window.$memory[$name] != undefined){
            return window.$memory[$name];
        }else{
            return false;
        }
    },
    resetForm:function($form){
        $($form)[0].reset();
        $($form).find("input[type=hidden]").val("");
    },
    loading:function(){
        $("#content").html('' +
            '<div class="container-fluid">' +
            '    <div class="animated fadeIn my-2">' +
            '        <img src="/bimg/Login/loader-lounge.gif?" class="img-fluid">' +
            '    </div>' +
            '</div>');
    },
    getAgentUI:function(){
        var $ua = navigator.userAgent.toLowerCase();
        return $ua.match(/msie ([\d.]+)/) ? $ua.match(/msie ([\d.]+)/)[0] : $ua.match(/firefox\/([\d.]+)/) ? $ua.match(/firefox\/([\d.]+)/) : $ua.match(/chrome\/([\d.]+)/) ? $ua.match(/chrome\/([\d.]+)/)[0] : $ua.match(/opera.([\d.]+)/) ? $ua.match(/opera.([\d.]+)/)[0] : $ua.match(/version\/([\d.]+).*safari/) ? $ua.match(/version\/([\d.]+).*safari/) : 'NotFound';
    },
    unlock:function($v){
        var $val = $v.split("");
        var $non = $v.split("");
        $non.reverse();
        var $res = [];
        var $ser = [];
        for(var $r = 0; $r < $val.length ; $r++){
            if(($r+1)%2==0){
                $res.push($val[$r]);
            }else{
                if(($val.length)%2==0){
                    $ser.push($non[$r+1]);
                }else{
                    $ser.push($non[$r]);
                }
            }
        }
        return atob($res.join("")+""+$ser.join(""));
    },
    lock:function($v){
        $v = btoa($v);
        var $val = $v.split("");
        var $non = $v.split("");
        $non.reverse();
        var $divi = 0;
        if(($val.length)%2 == 0){
            $divi = ($val.length)/2;
        }else{
            $divi = ((($val.length)-1)/2)+1;
            $val = $val.slice(0,$divi);
            $val.pop();
        }
        var $res = [];
        for(var $r = 0 ; $r < $divi ; $r++){
            $res.push($non[$r]);
            if($val[$r] != undefined){
                $res.push($val[$r]);
            }
        }
        return $res.join("");
    },
    ucfirst($str){
        return $str.charAt(0).toUpperCase() + $str.slice(1);
    }
};

$(document).ready(function(){
    libs.ajaxSetup();
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    $(window).unbind('resize').resize(function(){
        $(".login-section-wrapper").height($(window).height() + 300);
    });
    $(".login-section-wrapper").height($(window).height() + 300);
});
